import { useRef } from 'react';
function makeRefMap() {
  const map = new Map();

  /** Create a new ref object and add it to the map. */
  const newValue = key => {
    const v = {
      current: null
    };
    map.set(key, v);
    return v;
  };
  return key => map.get(key) ?? newValue(key);
}
export function useRefMap() {
  return useRef(makeRefMap()).current;
}